// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"f01efc07","142":"36579ed2","150":"cdf0ddf4","185":"4e1463e1","210":"8c023617","314":"3d2112fe","389":"dc8512bd","528":"30a38fd1","571":"5a8a39f9","912":"dc8512bd","954":"07d653ff"}[chunkId] + ".chunk.css";
};